import React from 'react'
import RadioGroup from '@mui/material/RadioGroup';
import RadioLabel from './utils/RadioLabel';
import StyledRadio from './utils/StyledRadio';
const ToggleMessageFilter = ({value , handleChange}) => {

 
  return (
<>



<RadioGroup
        row
        value={value}
        onChange={handleChange}
      >
        <RadioLabel value="MT" control={<StyledRadio />} label="MT" />
        <RadioLabel value="MX" control={<StyledRadio />} label="MX" />
</RadioGroup>
</>

    )
}

export default ToggleMessageFilter